<template>
  <div class="grid-x align-center cards">
    <div v-for="(card, index) in cards" class="cell" :class="cellClasses" :key="'card:' + index">
      <div class="card">
        <div class="image" :style="{backgroundImage: `url(${card.image.url})`}"/>
        <div class="content" :style="{backgroundColor: card.contentBackgroundColour}">
          <v-text class="text-content" :text="card.text"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VText from './Text';

  export default {
    props: {
      cards: Array
    },
    components: {
      VText
    },
    computed: {
      cellClasses() {
        let classes = [];
        if (this.cards.length === 1) {
          classes.push('small-12');
          classes.push('medium-6');
        }
        if (this.cards.length % 2 == 0) {
          classes.push('small-12');
          classes.push('medium-6');
        }
        if (this.cards.length % 3 == 0) {
          classes.push('small-12');
          classes.push('medium-4');
        }
        if (this.cards.length % 4 == 0) {
          classes.push('small-12');
          classes.push('medium-3');
        }
        return classes;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'foundation-sites/scss/foundation.scss';
  @import '@/assets/scss/_settings';
  .cards {
    @include breakpoint(medium) {
      margin: vw-relative(0 -16);
    }
  }
  .card {
   text-decoration: none;
   display: block;
   margin: vw-relative(0 0 20, 320);
   @include breakpoint(medium) {
     padding: 0 vw-relative(16);
     margin: vw-relative(40 0);
   }
  }
  .image {
   padding-top: 55%;
   background-position: center;
   background-size: cover;
   background-repeat: no-repeat;
  }
  .content {
   padding: vw-relative(20, 320);
   margin: vw-relative(-20 10 0, 320);
   text-align: center;
   @include breakpoint(medium) {
     padding: vw-relative(24);
     margin: vw-relative(-24 24 0);
   }
  }
</style>
